import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import { Clock } from "lucide-react";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("toate");

  useEffect(() => {
    http.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const filters = [
    { id: "toate", label: "Toate" },
    { id: "povesti", label: "Povești" },
    { id: "inspiratie", label: "Inspirație" },
    { id: "lansari", label: "Lansări" },
  ];

  const filtered = filter === "toate" ? posts : posts.filter((p) => p.category === filter);
  const [featured, ...rest] = filtered;

  const fmtDate = (iso) => new Date(iso).toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="py-16 md:py-24" data-testid="blog-page">
      <div className="container-vdz">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow mb-3">Jurnalul Vis de Zi</div>
          <h1 className="font-serif-display text-5xl md:text-6xl" style={{ color: "var(--vdz-navy)" }}>Povești, inspirație și lansări.</h1>
          <p className="mt-5 opacity-75 leading-relaxed">
            Scrisori blânde de la Alina Stancu — despre colorat, despre liniște, despre micile frumuseți ale fiecărei zile.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-12" data-testid="blog-filters">
          {filters.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              data-testid={`blog-filter-${f.id}`}
              className={`px-5 py-2 text-xs uppercase tracking-[0.2em] font-serif-accent border transition-all ${
                filter === f.id ? "bg-[color:var(--vdz-navy)] text-[color:var(--vdz-cream)] border-[color:var(--vdz-navy)]" : "bg-white text-[color:var(--vdz-navy)] border-[color:var(--vdz-cream-border)] hover:border-[color:var(--vdz-gold)]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {featured && (
          <Link to={`/jurnal/${featured.slug}`} className="group grid md:grid-cols-2 gap-8 md:gap-12 mb-16 items-center" data-testid={`blog-featured-${featured.slug}`}>
            <div className="aspect-[4/5] overflow-hidden gold-frame" style={{ background: "var(--vdz-navy)" }}>
              <img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span className="px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-serif-accent" style={{ background: "var(--vdz-navy)", color: "var(--vdz-cream)" }}>
                  {featured.category_label || featured.category}
                </span>
                <span className="eyebrow">Articol principal</span>
              </div>
              <h2 className="font-serif-display text-4xl md:text-5xl leading-tight group-hover:text-[color:var(--vdz-gold)] transition-colors" style={{ color: "var(--vdz-navy)" }}>
                {featured.title}
              </h2>
              <p className="mt-6 text-base md:text-lg opacity-80 leading-relaxed">{featured.excerpt}</p>
              <div className="mt-6 flex items-center gap-5 text-xs opacity-70 font-serif-accent uppercase tracking-[0.18em]">
                <span>{featured.author}</span>
                <span>·</span>
                <span>{fmtDate(featured.published_at)}</span>
                <span>·</span>
                <span className="flex items-center gap-1.5"><Clock size={12} /> {featured.reading_time} min</span>
              </div>
              <span className="mt-8 inline-block font-serif-accent uppercase tracking-[0.22em] text-xs gold-text">
                Citește articolul →
              </span>
            </div>
          </Link>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
          {rest.map((p) => (
            <Link key={p.id} to={`/jurnal/${p.slug}`} className="group block" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[4/5] overflow-hidden gold-frame mb-5" style={{ background: "var(--vdz-navy)" }}>
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <span className="px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] font-serif-accent" style={{ background: "var(--vdz-cream-warm)", color: "var(--vdz-navy)" }}>
                {p.category_label || p.category}
              </span>
              <h3 className="font-serif-display text-2xl mt-4 leading-tight group-hover:text-[color:var(--vdz-gold)] transition-colors" style={{ color: "var(--vdz-navy)" }}>
                {p.title}
              </h3>
              <p className="mt-3 text-sm opacity-75 clamp-3">{p.excerpt}</p>
              <div className="mt-4 flex gap-4 text-[10px] opacity-60 uppercase tracking-[0.18em] font-serif-accent">
                <span>{fmtDate(p.published_at)}</span>
                <span>·</span>
                <span>{p.reading_time} min</span>
              </div>
            </Link>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 opacity-60">
            <p className="font-serif-display text-xl">Nu există articole în această categorie încă.</p>
          </div>
        )}
      </div>
    </div>
  );
}
